import React from 'react';
import styled from 'styled-components';
import { CallButton, CallButtonVariant } from '@naf/call-button';
import { spacing } from '@naf/theme';

interface CallButtonSerializerProps {
  value: {
    phoneNumberToCall: string;
    text: string;
    variant: CallButtonVariant;
    withIcon: boolean;
  };
}

export const CallButtonBlock = ({
  value: { phoneNumberToCall, text, variant, withIcon },
}: CallButtonSerializerProps) => (
  <StyledCallButtonWrapper>
    <CallButton phoneNumberToCall={phoneNumberToCall} text={text} variant={variant} withIcon={withIcon} />
  </StyledCallButtonWrapper>
);

export const CallButtonBlockSerializer =
  () =>
  ({ value }: CallButtonSerializerProps) =>
    <CallButtonBlock value={value} />;

const StyledCallButtonWrapper = styled.div`
  margin: ${spacing.space16} 0;
`;
